<template>
	<div class="bg-gray">
		<BaseNav></BaseNav>
		<div class="main">
			<router-view></router-view>
		</div>
		<BaseFooter></BaseFooter>
	</div>
</template>

<script>
	import BaseNav from "@/components/BaseNavigation"
	import BaseFooter from "@/components/BaseFooter"
	export default{
		components:{
			BaseNav,
			BaseFooter,
		},
		data(){
			return{
				
			}
		},
		mounted() {
			document.title="雄安股权交易所-新闻公告";
		},
		methods:{
			
		}
	}
</script>

<style scoped="scoped">
	.bg-gray{
		background: #F6F7FC;
	}
	
	.main{
		min-height: 600px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/news/index.vue